import { Privilege } from './types';

export const ADD_LISTABLE_ATTRIBUTE: Privilege = 'add_listable_attribute';
export const ADD_PERSON: Privilege = 'add_person';
export const VIEW_ADVANCED_DOCUMENTATION: Privilege = 'view_advanced_documentation';
export const EXPORT_CSV_ACCESS: Privilege = 'export_csv_access';
export const DEACTIVATE_USER_ACCESS: Privilege = 'deactivate_user_access';
export const VIEW_AUDIT_LOG: Privilege = 'view_audit_log';
export const MODIFY_ATTRIBUTE_TYPE: Privilege = 'modify_attribute_type';
export const MODIFY_DEAD_ATTRIBUTE: Privilege = 'modify_dead_attribute';
export const SHOW_END_TIMES: Privilege = 'show_end_times';
